<template>
  <BaseSimpleLayout class="master-supplier-list">
    <template #title>仕入先一覧</template>
    <template v-if="loadingFlag" #button-area>
      <el-input
        v-model="searchText"
        size="large"
        placeholder="検索"
        @input="searchData"
      />
      <ScreenPermissionGate code="SUPPLIER-BTN_CREATE">
        <el-button
          type="success"
          size="large"
          @click="router.push('/master/supplier/create')"
        >
          仕入先登録
        </el-button>
      </ScreenPermissionGate>
    </template>
    <template v-if="loadingFlag" #main>
      <el-table :data="tableData" border :max-height="tableHeight">
        <el-table-column
          prop="id"
          label="ID"
          width="100"
          align="center"
          sortable
        />
        <el-table-column prop="name" label="名前" width="150" sortable>
          <template #default="scope">
            <router-link :to="`/master/supplier/${scope.row.id}`">{{
              scope.row.name
            }}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="post"
          label="郵便番号"
          width="150"
          align="center"
          sortable
        />
        <el-table-column
          prop="address"
          label="住所"
          width="500"
          align="center"
          sortable
        />
        <el-table-column
          prop="tel"
          label="電話番号"
          width="150"
          align="center"
          sortable
        />
      </el-table>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import { ElLoading } from 'element-plus';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';
  import { SupplierDataState } from '@/types/master/supplier';

  const store = useStore();
  const tableData = ref<SupplierDataState[]>([]);
  const loadingFlag = ref(false);
  const tableHeight = ref(600);
  const searchText = ref('');

  const initialize = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true });
    await store.dispatch('suppliersMaster/fetch');
    tableData.value = store.state.suppliersMaster.listData;
    tableHeight.value = window.innerHeight - 120;
    loadingInstance.close();
    loadingFlag.value = true;
  };
  const searchData = () => {
    const keyword = searchText.value?.toLowerCase().trim();

    tableData.value = store.state.suppliersMaster.listData.filter(
      (item: SupplierDataState) => {
        return [item.name, item.post, item.address, item.tel].some((field) =>
          field?.toLowerCase().includes(keyword)
        );
      }
    );
  };
  initialize();
</script>
<style lang="scss">
  .master-supplier-list {
    .el-input {
      width: 300px;
      margin: 0 20px;
    }
    .el-table {
      width: 1050px;
      margin: 10px auto 0;
      thead {
        th {
          background: #f5f7fa;
        }
      }
    }
    .el-button {
      font-weight: 600;
    }
  }
</style>
